<template lang="html">
  <div id="blog-page">

    <section class="main-section" data-aos="fade-in" data-aos-duration="1000">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">BLOG</h2>
          </div>

          <div class="col-12 col-results">
            <div class="row">
              <div class="col-lg-6 box-article-s1" v-for="(a, aInx) in blog" :key="'aInx-'+aInx">
                <router-link class="box" :to="'/blog/'+a.id">
                  <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+a.image+')' }">
                    <img src="public/images/pages/blog/article.png">
                  </div>

                  <div class="box-info">
                    <h5 class="title">{{ a.name }}</h5>

                    <div class="b-text" v-html="a.body"></div>
                  </div>
                </router-link>
              </div>

              <div class="col-12" v-if="blog.length == 0">
                <h4 class="text-center f-w-400">No se han escrito artículos aún.</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <loading-bg-component v-if="isLoading"></loading-bg-component>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,

      blog: [
        // { imageUrl: 'public/images/pages/blog/article-1.jpg',
        //   title: 'Ideas creativas que sorprenderán a todos: decoración y canciones',
        //   text: `
        //     Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        //   `
        // },
      ],
    }
  },

  methods: {
    getBlog() {
      this.isLoading = true;
      axios.post(tools.url('/api/blog')).then((response) =>{
        this.blog = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  beforeMount() {
    this.getBlog();
  }
}
</script>
